module.exports = __webpack_public_path__ + "static/media/EventOps.1f975625.png";